import { createContext, useContext } from "react";

import type { useQuiz } from "./useQuiz";

type QuizContextValue = ReturnType<typeof useQuiz>;

export const QuizContext = createContext<QuizContextValue | null>(null);

export function useQuizContext(): QuizContextValue {
  const ctx = useContext(QuizContext);

  if (!ctx) {
    throw new Error("useQuizContext must be used within QuizContext.Provider");
  }
  return ctx;
}
